/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PaymentArrangement;

(function (PaymentArrangement) {
  PaymentArrangement["JOVE_BILL"] = "jove_bill";
  PaymentArrangement["AGENCY_BILL"] = "agency_bill";
  PaymentArrangement["BOTH"] = "both";
  PaymentArrangement["NOT_CONFIRMED"] = "not_confirmed";
})(PaymentArrangement || (PaymentArrangement = {}));